export default "__VITE_ASSET__Dcv5dFd3__"